module.exports = __webpack_public_path__ + "img/international.6e3cf3d5.jpg";